<template>
  <div class="referred">
    <v-card-text>
      {{questionTitle}}
      <div class="req-list" >
        <div class="req-card" v-on:click="goToDetail(item)" v-for="item in request_items" :key="item.Id">
          <div>
            <v-row>
              <v-col cols="8" style="padding: 5px">
                <label style="font-weight: bold">{{item.AnswerDate}}</label>

              </v-col>
              <v-col cols="4" class="text-left" style="padding: 5px">

              </v-col>
            </v-row>
            <hr>
            <div class="flex-no-wrap justify-space-between">
              <div>

                <div
                  class="req-name"
                  v-html="item.Answer"
                ></div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="background-color:white;position: absolute;bottom: 0px;width: 100%;padding: 5px;height: 50px">
        <div style="width: 20%">
          <img @click="add_answer()" src="../../../public/img/vec_send.png" width="45px" height="auto"/>
        </div>
        <div style="width: 80%">

          <v-text-field
            label="Main input"
            :label="$t('answerMessage')"
            v-model="answer"
            hide-details="auto"
          ></v-text-field>
        </div>
      </div>
    </v-card-text>
  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading';

  export default {
    props: [
      'passing_data'
    ],
    data() {
      return {
        answer: '',
        questionTitle: '',
        list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        selected_branch: 0,
        request_items: [],
        last_request_items: [],
        show_loading: false,
        page: 0,
        rules: {
          required: value => !!value || 'الزامی',
          fullName: value => value.length <= 30 || 'ماکسیمم 30 کاراکتر می باشد.',
          PersianFullName: value => {
            const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
            return pattern.test(value) || 'نام و نام خانوادگی فارسی نیست.'
          },
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || 'فرمت موبایل صحیح نیست.'
          },
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
    },
    watch: {},
    mounted() {
      this.get_final_requests();
    },

    methods: {
      goToDetail(item) {
        // var passing_data = JSON.parse(localStorage.getItem('request_data'));
        // passing_data.cat_id = item_id;
        // localStorage.setItem("request_data",JSON.stringify(passing_data));
        if (item.IsFinalize == 1) {
          this.$router.push({name: 'ViewRequest', params: {rec_id: item.Id}})

        } else {
          this.$router.push({name: 'ViewPreRequest', params: {rec_id: item.Id}})
        }
      },
      get_request_address(item) {
        var address = "";
        if (item.CityName != null) {
          address += item.CityName + " ";
        }
        if (item.AreaName != null) {
          address += item.AreaName + " ";
        }
        return address
      },

      get_final_requests($state) {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId
        const send_data = {
          UserId: user_id,
          Count: this.page,
          QuestionId: this.$route.params.rec_id,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetAnswers', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              this.questionTitle = response.data.questionTitle
              self.request_items = [];
              var question = {
                Answer: response.data.questionBody,
                AnswerDate: "",
                Id: 30426,
                Images: [],
                IsAccept: 0,
                SelfId: null,
                UserId: "WTBZ7AN3QGWLJQMOQF53S7VCX7BMBLD4RWFINBQ",
                UserName: null,
              }
              self.request_items.push(question);

              response.data.answers.forEach(function (number) {
                self.request_items.push(number);
              });
            }
          }).catch(e => {
          this.errors.push(e);
        })

      },
      add_answer() {
        if (this.answer == '') {
          return
        }
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId
        const send_data = {
          UserId: user_id,
          Attachments: JSON.stringify([]),
          qId: this.$route.params.rec_id,
          Answer: this.answer,
        };

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ZkAddAnswer', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.answer = ''
              self.get_final_requests();
            }
          }).catch(e => {
          this.errors.push(e);
        })

      },
      infiniteHandler($state) {
        var self = this;
        console.log("first is " + this.first);
        if (this.first) {
          // $state.loaded();
          setTimeout(() => {

            $state.loaded();
          }, 1000);
          return false;
        }

        console.log("hiii" + self.last_request_items.length)
        setTimeout(() => {

          // if (self.last_request_items>0 ) {
          self.page += 1;
          self.get_pre_requests($state);
          // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
        }, 1000);


      },
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
